const RELOAD_KEY_PREFIX = 'ops:stale-chunk-reload:'

export function staleChunkReloadKey(version) {
  return `${RELOAD_KEY_PREFIX}${version || 'unknown'}`
}

export function claimStaleChunkReload(storage, version) {
  try {
    const key = staleChunkReloadKey(version)
    if (storage.getItem(key)) return false
    storage.setItem(key, '1')
    return true
  } catch {
    // If persistence is unavailable, staying on the error boundary is safer
    // than risking an unbounded reload loop.
    return false
  }
}

export function installStaleChunkRecovery({
  version,
  eventTarget = window,
  storage = window.sessionStorage,
  reload = () => window.location.reload(),
} = {}) {
  const onPreloadError = (event) => {
    if (!claimStaleChunkReload(storage, version)) return
    event.preventDefault()
    reload()
  }
  eventTarget.addEventListener('vite:preloadError', onPreloadError)
  return () => eventTarget.removeEventListener('vite:preloadError', onPreloadError)
}
